var React = require('react');

function ToggleOn (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 384a128 128 0 1 1 128-128 127.93 127.93 0 0 1-128 128z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320a128 128 0 1 1 128-128 127.93 127.93 0 0 1-128 128z","className":"fa-primary","key":2})]);
}

ToggleOn.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = ToggleOn;

ToggleOn.default = ToggleOn;
